import React, { useEffect } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'
import logo from '../asset/images/logo.svg'
import { CAREERS_BASE } from './careersRoutes'

const PublicCareersLayout = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white shadow-sm">
        <div className="mx-auto flex h-14 max-w-6xl items-center justify-between gap-3 px-4 sm:h-16 sm:px-6">
          <Link to="/" className="flex min-w-0 items-center gap-2">
            <img className="h-8 w-8 shrink-0" src={logo} alt="EmployMeGlobal logo" />
            <span className="truncate text-lg font-semibold text-slate-900">EmployMeGlobal</span>
          </Link>
          <nav className="flex shrink-0 items-center gap-2 sm:gap-3">
            <Link
              to={CAREERS_BASE}
              className="rounded-lg px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-100 sm:text-sm"
            >
              All jobs
            </Link>
            <Link
              to="/login"
              className="rounded-lg px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-100 sm:text-sm"
            >
              Sign in
            </Link>
            <Link
              to="/signup"
              className="rounded-lg bg-[#00A5E6] px-3 py-2 text-xs font-medium text-white hover:bg-[#008FCC] sm:text-sm"
            >
              Sign up
            </Link>
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-6 sm:px-6 sm:py-8">
        <Outlet />
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-4 py-6 text-center text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between sm:text-left sm:px-6">
          <p>Public job listings — no account required to browse.</p>
          <Link to="/" className="font-medium text-slate-700 hover:text-slate-900">
            Back to home
          </Link>
        </div>
      </footer>
    </div>
  )
}

export default PublicCareersLayout
